import { createAction } from 'redux-act';

export const hideCrossPromotionModal = createAction();
export const showCrossPromotionModal = createAction();